import classNames from 'classnames';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';

import FormErrorMessage from '../FormErrorMessage';

const FormInput = ({
  autoComplete,
  autoFocus,
  disabled,
  hidden,
  id,
  inputMode,
  isLabelActive,
  label,
  name,
  type,
  wrapperClassName,
}) => {
  const { errors, touched } = useFormikContext();

  return hidden ? (
    <Field type="hidden" name={name} id={id} />
  ) : (
    <div className={classNames(wrapperClassName, 'md-form input-group mt-3 flex-column')}>
      <Field
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className={classNames('form-control', {
          'validate invalid': errors[name] && touched[name],
        })}
        disabled={disabled}
        id={id}
        inputMode={inputMode}
        name={name}
        type={type}
      />

      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className={classNames({
          active: isLabelActive,
        })}
        htmlFor={name}
      >
        {label}
      </label>

      <FormErrorMessage name={name} />
    </div>
  );
};

FormInput.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputMode: PropTypes.string,
  isLabelActive: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
};

export default FormInput;
